var map = {
	"./AlignMirror.PNG": 8488,
	"./CheckGameName.PNG": 1605,
	"./FollowLightV2.PNG": 7095,
	"./FollowLightV3.PNG": 8077,
	"./FollowTheLights.PNG": 9593,
	"./Lever.PNG": 2089,
	"./LeverPuzzle.PNG": 9059,
	"./LightsOut.PNG": 5190,
	"./Memory.PNG": 6280,
	"./SequenceCages.PNG": 3914,
	"./SequenceFire.PNG": 8693,
	"./SewerPuzzle.PNG": 3565,
	"./Shrine.PNG": 5468,
	"./Simon.PNG": 9349,
	"./SliderTile.PNG": 3176,
	"./WaterPuzzle.PNG": 6718,
	"./WaterPuzzle2.PNG": 4883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9046;